import React from 'react';
import { FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { FiPhone, FiMail} from "react-icons/fi";
import { BsEnvelopeCheck } from "react-icons/bs";
import { IoLocationOutline } from "react-icons/io5";
import Map from './Map';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
        <div className="footer-logo-mobile">
          <img 
            src={"/assets/images/Andolfatto Logo White.png"} 
            alt="Andolfatto Insurance Broker Logo" 
          />
        </div>
      <div className="footer-section">
        <div className="footer-icon-title">
          <h3>Dove Trovarci</h3>
        </div>
        <Map />
        <p>         
         <a
            href="https://www.google.com/maps?q=Piazza+Torre,+29,+36060+Romano+d'Ezzelino+VI"
            target="_blank"
            rel="noopener noreferrer"
            className='maps'
          >
          <IoLocationOutline/> Piazza Torre, 29 - 36060 Romano d'Ezzelino VI
          </a></p>
      </div>
      <div className="footer-section-merged">
          <img src={"/assets/images/Andolfatto Logo White.png"}
            alt="Andolfatto Insurance Broker Logo"
          />
        <div className="merged-content">
          <div className="contact-details-mobile">
            <h4>Contatti</h4>
            <p><FiMail /> <a href="mailto:broker@andolfatto.net">broker@andolfatto.net</a></p>
            <p><BsEnvelopeCheck /> <a href="mailto:amministrazione@pec.andolfattobroker.it" className="pec-link">amministrazione@pec.andolfattobroker.it</a></p>
            <p><FiPhone /> <a href="tel:+390424287372">+39 0424 287372</a></p>
            <p><FaWhatsapp /> <a href="https://wa.me/393925446331" target="_blank" rel="noopener noreferrer">+39 392 5446331</a></p>
          </div>
          <div className="opening-hours">
            <h4>Orari di Apertura</h4>
            <p>dal Lunedì al Venerdì :</p>
            <p>9:30 - 13:00 / 15:30 - 18:30 su appuntamento</p>
          </div>
          <div className="contact-details">
            <h4>Contatti</h4>
            <p><FiMail /> <a href="mailto:broker@andolfatto.net">broker@andolfatto.net</a></p>
            <p><BsEnvelopeCheck /> <a href="mailto:amministrazione@pec.andolfattobroker.it" className="pec-link">amministrazione@pec.andolfattobroker.it</a></p>
            <p><FiPhone /> <a href="tel:+390424287372">+39 0424 287372</a></p>
            <p><FaWhatsapp /> <a href="https://wa.me/393925446331" target="_blank" rel="noopener noreferrer">+39 392 5446331</a></p>
          </div>
        </div>
        <div className="legal-info">
          <p>P.IVA 04395610241 - REA VI - 401047</p>
          <p><a href="https://ruipubblico.ivass.it/rui-pubblica/ng/#/home" target="_blank" rel="noopener noreferrer" className="ivass-link">Sito Internet IVASS</a></p>
          <p className="ivass-info">ANDOLFATTO LAURA - N° Iscrizione RUI: B 000229515</p>
          <p className="ivass">Autorità competente alla vigilanza - IVASS - Via del Quirinale 21, 00187 ROMA</p>
          {/*Per Reclami : <a href="mailto:tutela.consumatore@pec.ivass.it" className="pec-link">tutela.consumatore@pec.ivass.it </a>*/}<p className="ivass">info su <a href="https://www.ivass.it/?dotcache=refresh" target="_blank" rel="noopener noreferrer" className="ivass">www.ivass.it</a></p>
        </div>
        <div className="social-icons">
          <a href="https://www.linkedin.com/in/laura-andolfatto/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
